import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles<
  { isActive: boolean },
  "icon" | "activeIcon"
>()((theme, { isActive }, classes) => ({
  link: {
    textDecoration: "none",
    color: "inherit",
  },
  container: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(2.5, 3),
    cursor: "pointer",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "#f5f5f5",
      [`& .${classes.icon}`]: {
        display: "none",
      },
      [`& .${classes.activeIcon}`]: {
        display: "grid",
      },
    },
    [theme.breakpoints.up("lg")]: {
      gap: theme.spacing(4),
    },
  },
  icon: {
    display: isActive ? "none" : "grid",
    placeItems: "center",
    color: theme.palette.primary.main,
    "& > svg": {
      width: 18,
      height: 18,
    },
    [theme.breakpoints.up("lg")]: {
      "& > svg": {
        width: 24,
        height: 24,
      },
    },
  },
  activeIcon: {
    display: isActive ? "grid" : "none",
    placeItems: "center",
    color: theme.palette.primary.main,
    "& > svg": {
      width: 18,
      height: 18,
    },
    [theme.breakpoints.up("lg")]: {
      "& > svg": {
        width: 24,
        height: 24,
      },
    },
  },
  label: {
    fontSize: "0.88rem",
    fontWeight: 400,
    color: theme.palette.primary.main,
    [theme.breakpoints.up("lg")]: {
      fontSize: "1rem",
    },
  },
  newIcon: {
    backgroundColor: theme.palette.secondary.main,
    color: "#ffffff",
  },
  activeLink: {
    backgroundColor: "#E9E9E9",
    "&:hover": {
      backgroundColor: "#E9E9E9",
    },
  },
}));
